import { render, staticRenderFns } from "./importExport.vue?vue&type=template&id=1d63b9da&scoped=true&"
import script from "./importExport.vue?vue&type=script&lang=js&"
export * from "./importExport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d63b9da",
  null
  
)

export default component.exports